module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BoldItalic-76b71898a48cc65f83368213ce8cd23b.woff2";